import React from "react"
import { Helmet } from "react-helmet"

import Products from "../components/Products"

const IndexPage = () => (
  <>
    <Helmet>
      <title>Products | au et chiu Import Export</title>
      <link rel="canonical" href="https://auetchiu.com" />
    </Helmet>
    <div className="o-section o-grid">
      <div className="o-grid__item--wide">
        <h1 className="c-heading c-text--centered c-text--green">WHAT CAN WE <span className="c-line c-line--under">DO?</span></h1>
        <Products />
      </div>
    </div>
  </>
)

export default IndexPage
